import React, { FC } from "react";
import style from "./style.module.scss";
import { SmallLoader } from "../Loader";
import { format, parse } from "date-fns";
import { de } from "date-fns/locale";

interface IDatesSelector {
  isLoading: boolean;
  isLoaded?: boolean;
  dates: { date: string }[];
  onDateClick: (data: { date: string }) => void;
  selectedDate?: string;
  isDisabled?: boolean;
  isDateActive?: boolean;
  additionalCriteria?: boolean;
  shouldBeDateParsed?: boolean;
  parseFormat?: string;
}

export const DatesSelector: FC<IDatesSelector> = ({
  dates,
  isLoaded = true,
  isLoading,
  onDateClick,
  selectedDate,
  isDisabled,
  isDateActive = true,
  additionalCriteria = true,
  parseFormat,
  shouldBeDateParsed,
}) => {
  return (
    <div className={style.selectDateItemWrapper}>
      {isLoading ? (
        <div className={style.loaderWrapper}>
          <SmallLoader />
        </div>
      ) : dates.length ? (
        dates.map((item: { date: string }, index: any) => {
          return (
            <button
              key={index}
              role="radio"
              aria-checked={selectedDate === item.date}
              type="button"
              onClick={() => {
                if (isDisabled) {
                  return;
                }
                onDateClick(item);
              }}
              className={`${style.dateItemWrapper} ${
                selectedDate === item.date ? style.selectedDateItemWrapper : ""
              }`}
              style={{
                opacity: isDateActive && additionalCriteria ? 1 : 0.5,
                cursor: isDateActive && additionalCriteria ? "pointer" : "auto",
              }}
            >
              {shouldBeDateParsed && parseFormat
                ? format(
                    new Date(parse(item.date, parseFormat, new Date())),
                    "dd. LLLL yyyy",
                    {
                      locale: de,
                    },
                  )
                : format(new Date(item.date), "dd. LLLL yyyy", {
                    locale: de,
                  })}
              {/* {new Date(
                parse(item.date, "dd.MM.yyyy", new Date()),
              ).toDateString()} */}
              {/* {format(new Date(item.date), "dd. LLLL yyyy", {
                locale: de,
              })} */}
            </button>
          );
        })
      ) : (
        <p className={style.noItemsFound}>Es wurden keine Termine gefunden</p>
      )}
    </div>
  );
};
